import React, {Component}  from 'react';
import { Table, FormGroup, Label, Input } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import authService from '../../services/auth';
import reportService from '../../services/report';
import './UserStatsReport.css';

class UserStatsReport extends Component {
  constructor ( props ) {
    super( props );
    this.user = authService.getUserFromToken() || {};
    this.state = {
                  stats: {},
                  selectedYear: '',
                  years: this.generateYears()
                };
    // Hardcoded mentees with mentors for historical years (before data capture)
    this.menteesWithMentorsByYear = {
      '2016': 14,
      '2017': 48,
      '2018': 35,
      '2019': 15,
      '2020': 10,
      '2021': 8,
      '2022': 7,
      '2023': 8
    };
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const years = ['All Years'];
    for (let year = currentYear; year >= 2016; year--) {
      years.push(year.toString());
    }
    return years;
  }

  handleYearChange = async (e) => {
    const selectedYear = e.target.value === 'All Years' ? '' : e.target.value;
    this.setState({ selectedYear });
    const stats = await reportService.getUserStatsReport(selectedYear || null);
    this.setState({ stats });
  }

  async componentDidMount() {
    if (!this.user || this.user.userTypeId !== 3) {
      return;
    }
    const stats = await reportService.getUserStatsReport();
    this.setState({ stats }); 
  }

  // Proportional rounding - ensures percentages sum to exactly 100
  proportionalRound(values) {
    if (!values || values.length === 0) return [];
    
    // Convert to percentages and calculate floors
    const percentages = values.map(v => (v || 0) * 100);
    const floors = percentages.map(p => Math.floor(p));
    const remainders = percentages.map((p, i) => ({ index: i, remainder: p - floors[i] }));
    
    // Sort by remainder descending
    remainders.sort((a, b) => b.remainder - a.remainder);
    
    // Calculate how many points need to be distributed
    const sumFloors = floors.reduce((a, b) => a + b, 0);
    const pointsToDistribute = 100 - sumFloors;
    
    // Distribute points to items with largest remainders
    const result = [...floors];
    for (let i = 0; i < pointsToDistribute && i < remainders.length; i++) {
      result[remainders[i].index]++;
    }
    
    return result;
  }

  render () {
    let {stats} = this.state;

    // Calculate proportionally rounded percentages for Gender
    const genderValues = [
      stats.PercentMenteeMales,
      stats.PercentMenteeFemales
    ];
    const [malesPct, femalesPct] = this.proportionalRound(genderValues);

    // Calculate proportionally rounded percentages for Branch of Service
    const branchValues = [
      stats.PercentMenteeUSAF,
      stats.PercentMenteeUSArmy,
      stats.PercentMenteeUSCG,
      stats.PercentMenteeUSMC,
      stats.PercentMenteeUSNavy
    ];
    const [usafPct, armyPct, coastGuardPct, marinesPct, navyPct] = this.proportionalRound(branchValues);

    // Calculate proportionally rounded percentages for Current Status
    const currentStatusValues = [
      stats.PercentMenteeActiveDuty,
      stats.PercentMenteeStudent,
      stats.PercentMenteeEmployed,
      stats.PercentMenteeVeteranLookingForEmployment
    ];
    const [activeDutyPct, studentPct, employedPct, veteranPct] = this.proportionalRound(currentStatusValues);

    // Calculate proportionally rounded percentages for Education Level
    const educationValues = [
      stats.PercentMenteeSomeSchool,
      stats.PercentMenteeHighSchoolDiploma,
      stats.PercentMenteeSomeCollege,
      stats.PercentMenteeCollegeDegree,
      stats.PercentMenteePostGraduateDegree,
      stats.PercentMenteeOtherEducation
    ];
    const [someSchoolPct, highSchoolPct, someCollegePct, collegePct, postGradPct, otherEdPct] = this.proportionalRound(educationValues);

    // Calculate proportionally rounded percentages for Mentor Gender
    const mentorGenderValues = [
      stats.PercentMentorMales,
      stats.PercentMentorFemales
    ];
    const [mentorMalesPct, mentorFemalesPct] = this.proportionalRound(mentorGenderValues);

    // Calculate proportionally rounded percentages for Mentee Career Interests
    const menteeCareerValues = [
      stats.PercentMenteeProjectManagement,
      stats.PercentMenteeFinancialManagement,
      stats.PercentMenteeInformationTechnology,
      stats.PercentMenteeMarketing,
      stats.PercentMenteeChangeManagement,
      stats.PercentMenteeCommunications,
      stats.PercentMenteeSalesBusinessDevelopment,
      stats.PercentMenteeBusinessProcessManagement
    ];
    const [
      menteeProjMgmtPct,
      menteeFinMgmtPct,
      menteeITPct,
      menteeMarketingPct,
      menteeChangeMgmtPct,
      menteeCommPct,
      menteeSalesPct,
      menteeBPMPct
    ] = this.proportionalRound(menteeCareerValues);

    // Calculate proportionally rounded percentages for Mentee Industry Interests
    const menteeIndustryValues = [
      stats.PercentMenteeGovernment,
      stats.PercentMenteeConsulting,
      stats.PercentMenteeInsurance,
      stats.PercentMenteeFinancialServices,
      stats.PercentMenteeEducation,
      stats.PercentMenteeNonprofit,
      stats.PercentMenteeHealthcare,
      stats.PercentMenteeManufacturing,
      stats.PercentMenteeLogisticsTransportation
    ];
    const [
      menteeGovPct,
      menteeConsultingPct,
      menteeInsurancePct,
      menteeFinSvcPct,
      menteeEduPct,
      menteeNonprofitPct,
      menteeHealthcarePct,
      menteeMfgPct,
      menteeLogisticsPct
    ] = this.proportionalRound(menteeIndustryValues);

    // Calculate proportionally rounded percentages for Mentor Career Interests
    const mentorCareerValues = [
      stats.PercentMentorProjectManagement,
      stats.PercentMentorFinancialManagement,
      stats.PercentMentorInformationTechnology,
      stats.PercentMentorMarketing,
      stats.PercentMentorChangeManagement,
      stats.PercentMentorCommunications,
      stats.PercentMentorSalesBusinessDevelopment,
      stats.PercentMentorBusinessProcessManagement
    ];
    const [
      mentorProjMgmtPct,
      mentorFinMgmtPct,
      mentorITPct,
      mentorMarketingPct,
      mentorChangeMgmtPct,
      mentorCommPct,
      mentorSalesPct,
      mentorBPMPct
    ] = this.proportionalRound(mentorCareerValues);

    // Calculate proportionally rounded percentages for Mentor Industry Interests
    const mentorIndustryValues = [
      stats.PercentMentorGovernment,
      stats.PercentMentorConsulting,
      stats.PercentMentorInsurance,
      stats.PercentMentorFinancialServices,
      stats.PercentMentorEducation,
      stats.PercentMentorNonprofit,
      stats.PercentMentorHealthcare,
      stats.PercentMentorManufacturing,
      stats.PercentMentorLogisticsTransportation
    ];
    const [
      mentorGovPct,
      mentorConsultingPct,
      mentorInsurancePct,
      mentorFinSvcPct,
      mentorEduPct,
      mentorNonprofitPct,
      mentorHealthcarePct,
      mentorMfgPct,
      mentorLogisticsPct
    ] = this.proportionalRound(mentorIndustryValues);

    return (
      <>
      <div className='pt-5 report-container'>
      <h3 style={{fontWeight: 'bold'}}>Signups in {this.state.selectedYear || 'All Years'}</h3>
      <FormGroup >
        <Label for="yearSelect" style={{marginRight: '10px', fontWeight: 'bold'}}>Filter by Year:</Label>
        <Input
          type="select"
          name="year"
          id="yearSelect"
          value={this.state.selectedYear || 'All Years'}
          onChange={this.handleYearChange}
          style={{width: '200px', display: 'inline-block'}}
        >
          {this.state.years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </Input>
      </FormGroup>
      <Table>
          <thead>
            <tr>
              <th width={this.state.selectedYear ? '33.33%' : '50%'}>Mentees</th>
              {this.state.selectedYear && <th width='33.33%'>Mentees w/ Mentors</th>}
              <th width={this.state.selectedYear ? '33.33%' : '50%'}>Mentors</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                  <td>{stats.SignupsByYearMentees || 0}</td>
                  {this.state.selectedYear && <td>{this.menteesWithMentorsByYear[this.state.selectedYear] ? this.menteesWithMentorsByYear[this.state.selectedYear] : (stats.SignupsByYearMenteesWithMentors || 0)}</td>}
                  <td>{stats.SignupsByYearMentors || 0}</td>
              </tr>
          </tbody>
      </Table>
      </div>
      <div className='report-container'>
      <h3 style={{fontWeight: 'bold'}}>Mentees</h3>
      <Table>
          <thead>
            <tr>
              <th width='33.33%'>Total Mentees</th>
              <th width='33.33%'>Mentees w/ Mentors</th>
              <th width='33.33%'>Mentees w/ No Mentors</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                  <td>{stats.TotalMentees}</td>
                  <td>{stats.MenteesWithMentors}</td>
                  <td>{stats.MenteesWithNoMentors}</td>
              </tr>
          </tbody>
      </Table>
      <Table>
          <thead>
            <tr>
              {/* <th width='25%'>College Degree</th> */}
              <th width='25%'>Avg Years of Service</th>
              <th width='25%'>Male</th>
              <th width='25%'>Female</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                  {/* <td>{Math.round(stats.PercentMenteeDegrees * 100)}%</td> */}
                  <td>{(parseFloat(stats.AvgYearsOfService)).toFixed(1)}</td>
                  <td>{malesPct}%</td>
                  <td>{femalesPct}%</td>
              </tr>
          </tbody>
      </Table>
      <h4 style={{fontWeight: 'bold'}}>Branch of Service</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>US Air Force</th>
              <th>US Army</th>
              <th>US Coast Guard</th>
              <th>US Marine Corps</th>
              <th>US Navy</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{usafPct}%</td>
              <td>{armyPct}%</td>
              <td>{coastGuardPct}%</td>
              <td>{marinesPct}%</td>
              <td>{navyPct}%</td>
            </tr>
          </tbody>
      </Table>
       <h4 style={{fontWeight: 'bold'}}>Current Status</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Active Duty</th>
              <th>Student</th>
              <th>Employed</th>
              <th>Veteran Looking For Employment</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{activeDutyPct}%</td>
              <td>{studentPct}%</td>
              <td>{employedPct}%</td>
              <td>{veteranPct}%</td>
            </tr>
          </tbody>
      </Table>
       <h4 style={{fontWeight: 'bold'}}>Education Level</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Some School</th>
              <th>High School Diploma</th>
              <th>Some College</th>
              <th>College Degree</th>
              <th>Post Graduate Degree</th>
               <th>Other Education</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{someSchoolPct}%</td>
              <td>{highSchoolPct}%</td>
              <td>{someCollegePct}%</td>
              <td>{collegePct}%</td>
              <td>{postGradPct}%</td>
              <td>{otherEdPct}%</td>
            </tr>
          </tbody>
      </Table>
      <h4 style={{fontWeight: 'bold'}}>Career Interests</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Project Management</th>
              <th>Financial Management</th>
              <th>Information Technology</th>
              <th>Marketing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{menteeProjMgmtPct}%</td>
              <td>{menteeFinMgmtPct}%</td>
              <td>{menteeITPct}%</td>
              <td>{menteeMarketingPct}%</td>
            </tr>
          </tbody>
      </Table>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Change Management</th>
              <th>Communications</th>
              <th>Sales/Business Development</th>
              <th>Business Process Management</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{menteeChangeMgmtPct}%</td>
              <td>{menteeCommPct}%</td>
              <td>{menteeSalesPct}%</td>
              <td>{menteeBPMPct}%</td>
            </tr>
          </tbody>
      </Table>
      <h4 style={{fontWeight: 'bold'}}>Industry Interests</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Government</th>
              <th>Consulting</th>
              <th>Insurance</th>
              <th>Financial Services</th>
              <th>Education</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{menteeGovPct}%</td>
              <td>{menteeConsultingPct}%</td>
              <td>{menteeInsurancePct}%</td>
              <td>{menteeFinSvcPct}%</td>
              <td>{menteeEduPct}%</td>
            </tr>
          </tbody>
      </Table>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Nonprofit</th>
              <th>Healthcare</th>
              <th>Manufacturing</th>
              <th>Logistics/Transportation</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{menteeNonprofitPct}%</td>
              <td>{menteeHealthcarePct}%</td>
              <td>{menteeMfgPct}%</td>
              <td>{menteeLogisticsPct}%</td>
            </tr>
          </tbody>
      </Table>
      </div>
      <div className='pt-5 report-container'>
      <h3 style={{fontWeight: 'bold'}}>Mentors</h3>
      <Table>
          <thead>
            <tr>
              <th width='25%'>Total Mentors</th>
              <th width='25%'>Total Current Mentors</th>
              <th width='25%'>Mentors w/ Case</th>
              <th width='25%'>Mentors w/ No Case</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                  <td>{stats.TotalMentors}</td>
                  <td>{stats.TotalCurrentMentors}</td>
                  <td>{stats.TotalMentorsCase}</td>
                  <td>{stats.TotalMentorsNoCase}</td>
              </tr>
          </tbody>
      </Table>
      <Table>
          <thead>
            <tr>
              <th width='25%'>College Degree</th>
              <th width='25%'>Veteran</th>
              <th width='25%'>Male</th>
              <th width='25%'>Female</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                  <td>{Math.round(stats.PercentMentorDegrees * 100)}%</td>
                  <td>{Math.round(stats.PercentMentorVeterans * 100)}%</td>
                  <td>{mentorMalesPct}%</td>
                  <td>{mentorFemalesPct}%</td>
              </tr>
          </tbody>
      </Table>
      <h4 style={{fontWeight: 'bold'}}>Career Interests</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Project Management</th>
              <th>Financial Management</th>
              <th>Information Technology</th>
              <th>Marketing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{mentorProjMgmtPct}%</td>
              <td>{mentorFinMgmtPct}%</td>
              <td>{mentorITPct}%</td>
              <td>{mentorMarketingPct}%</td>
            </tr>
          </tbody>
      </Table>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Change Management</th>
              <th>Communications</th>
              <th>Sales/Business Development</th>
              <th>Business Process Management</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{mentorChangeMgmtPct}%</td>
              <td>{mentorCommPct}%</td>
              <td>{mentorSalesPct}%</td>
              <td>{mentorBPMPct}%</td>
            </tr>
          </tbody>
      </Table>
      <h4 style={{fontWeight: 'bold'}}>Industry Interests</h4>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Government</th>
              <th>Consulting</th>
              <th>Insurance</th>
              <th>Financial Services</th>
              <th>Education</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{mentorGovPct}%</td>
              <td>{mentorConsultingPct}%</td>
              <td>{mentorInsurancePct}%</td>
              <td>{mentorFinSvcPct}%</td>
              <td>{mentorEduPct}%</td>
            </tr>
          </tbody>
      </Table>
      <Table>
          <thead>
            <tr className='branch'>
              <th>Nonprofit</th>
              <th>Healthcare</th>
              <th>Manufacturing</th>
              <th>Logistics/Transportation</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{mentorNonprofitPct}%</td>
              <td>{mentorHealthcarePct}%</td>
              <td>{mentorMfgPct}%</td>
              <td>{mentorLogisticsPct}%</td>
            </tr>
          </tbody>
      </Table>
      </div>
      </>
      );
    }
}

export default withRouter(UserStatsReport);